import leavesApi from "@/api/leaves";

const actions = {
    create: async (context, dto) => (await leavesApi.create(dto)).data,
    getMyRequests: async () => (await leavesApi.getMyRequests()).data,
    cancel: async (context, id) => { await leavesApi.cancel(id); },
    canManage: async () => (await leavesApi.canManage()).data,
    getAdminList: async (context, params) => (await leavesApi.getAdminList(params)).data,
    approve: async (context, { id, note }) => (await leavesApi.approve(id, note)).data,
    reject: async (context, { id, note }) => (await leavesApi.reject(id, note)).data,
};

export default {
    namespaced: true,
    actions,
};
